import Vue from 'vue'

import dayjs from '@/dayjs'

import { capitalize, humanize, toCurrency } from './globalMixin'

export const longDateFormat = 'Do MMMM, YYYY'
export const compactDateFormat = 'D MMM, YYYY'

Vue.filter('toCurrency', toCurrency)
Vue.filter('humanize', humanize)
Vue.filter('capitalize', capitalize)

Vue.filter(
  'formatDate',
  (date: string, formatStyle: string, format: string) => {
    if (format) {
      return dayjs(date).format(format)
    }

    switch (formatStyle) {
      case 'long':
        format = longDateFormat
        break
      case 'compact':
        format = compactDateFormat
        break
    }

    return dayjs(date).format(format)
  },
)
